import { handle400Statuses, sendApiRequest } from './api';
import { logNetRequest } from '@utils/usefulFuncs';

export const fetchMemoryKeys = async () => {
  const URL = 'v1/genai/agent_memory/keys';
  const { status, data } = await sendApiRequest('get', URL);
  logNetRequest(status, data, URL);
  handle400Statuses(status);
  if (status === 200) {
    return data.keys;
  }
  console.error('Error fetching memory keys', data);
  return null;
};

export const getKeyValue = async (key) => {
  const URL = `v1/genai/agent_memory?keys=${key}`;
  const { status, data } = await sendApiRequest('get', URL);
  logNetRequest(status, data, URL);
  handle400Statuses(status);
  if (status === 200) {
    return data.memory_objects[0].data;
  }
  console.error('Error fetching memory key', data);
  return null;
};

export const updateMemoryKeyValue = async (key, value, editedByUserId) => {
  const URL = 'v1/genai/agent_memory';
  const sanitizedValue = JSON.parse(value);
  const form = {
    key,
    data: sanitizedValue,
    edited_by_user_id: editedByUserId,
  };
  const { status, data } = await sendApiRequest('post', URL, form);
  logNetRequest(status, data, URL);
  handle400Statuses(status);
  if (status === 200) {
    return true;
  }
  console.error('Error updating memory key', data);
  return false;
};

export const registerMemoryKey = async (key) => {
  const URL = 'v1/genai/agent_memory/register_key';
  const { status, data } = await sendApiRequest('post', URL, { key });
  logNetRequest(status, data, URL);
  handle400Statuses(status);
  if (status === 200) {
    return data;
  }
  console.error('Error registering memory key', data);
  return null;
};
